// Main Services Cards
import MyAccounts from "../views/MyAccounts/MyAccounts.jsx";
import FraudRiskManagement from "../views/MyAccounts/FraudRiskManagement.jsx";
import voucherManagement from "../views/MyAccounts/voucherManagement";
import CurrencyManagement from "../views/MyAccounts/CurrencyManagement";
import WalletManagement from "../views/MyAccounts/WalletManagement";
import LimitManagement from "../views/MyAccounts/LimitManagement";
import KycManagement from "../views/MyAccounts/KycManagement";
import FeeManagementService from "../views/MyAccounts/FeeManagement";
import InvoiceManagement from "../views/MyAccounts/InvoiceManagement";
import GateWayServiceManagement from "../views/MyAccounts/GateWayServiceManagement";
import Settings from "../views/MyAccounts/Settings";
import ViewConfiguration from "../views/Settings/ViewConfiguration.jsx";
import CommonConfiguration from "../views/Settings/CommonConfiguration.jsx";
import addNotification from "../views/Settings/addNotification.jsx"
//
import MainDashboard from "../views/MainDashboard/MainDashboard";
import CustomerMaster from "../views/AccountManagement/CustomerMaster.jsx";
import CreateWallet from "../views/AccountManagement/CreateWallet";
import ManualOTP from "../views/AccountManagement/ManualOTP.jsx";
import ManualUpgrade from "../views/AccountManagement/ManualUpgrade";
import indvidualEntity from "../views/AccountManagement/IndividualEntity";
import ManualDeposit from "../views/ManualDeposit/ManualDeposit.jsx";
import UnlockCustomerAccount from "../views/UnlockCustomerAccount/UnlockCustomerAccount";
import LegalEntity from "../views/AccountManagement/LegalEntity";
import GetCustomerDetails from "../views/AccountManagement/GetCustomerDetails.jsx";
import ActionCustomerMaster from "../views/AccountManagement/ActionCustomerMaster.jsx";
import AddNewCustomerWallet from "../views/AccountManagement/addNewCustomerWallet.jsx";
import CreateFeeWallet from "../views/AccountManagement/CreateFeeWallet.jsx";
import VoucherMapping from "../views/VoucherManagement/VoucherMapping.jsx";
import VoucherTransaction from "../views/VoucherManagement/VoucherTransaction.jsx";
import Vouchers from "../views/VoucherManagement/Vouchers.jsx";
import Redeem from "../views/VoucherManagement/Redeem.jsx";
import GetVoucherTransactionDetails from "../views/VoucherManagement/GetVoucherTransactionDetails.jsx";
import VoucherDetails from "../views/VoucherManagement/VoucherDetails.jsx";
import RedeemDetails from "../views/VoucherManagement/RedeemDetails.jsx";
import RiskRule from "../views/FraudRiskManagement/RiskRule.jsx";
import BlockCountry from "../views/FraudRiskManagement/BlockCountry.jsx";
import AllowCountry from "../views/FraudRiskManagement/AllowCountry.jsx";
import RuleMapping from "../views/FraudRiskManagement/RuleMapping.jsx";
import CurrenMaster from "../views/CurrencyManagement/CurrencyMaster.jsx";
import ConversionRate from "../views/CurrencyManagement/ConversionRate.jsx";
import WalletTransaction from "../views/WalletManagement/WalletTransaction.jsx";
import OperationLogs from "../views/WalletManagement/OperationLogs.jsx";
import LoyaltyPointsA from "../views/WalletManagement/LoyalPoints.jsx";
import SummaryReport from "../views/WalletManagement/SummaryReport.jsx";
import FeeReport from "../views/WalletManagement/FeeReport.jsx";
import WithdrawLimit from "../views/LimitManagement/WithdrawLimit.jsx";
import UserWithdrawLimit from "../views/LimitManagement/UserWithdrawLimit.jsx";
import LoadLimit from "../views/LimitManagement/LoadLimit.jsx";
import SendLimit from "../views/LimitManagement/SendLimit.jsx";
import WLAddWithdrawLimit from "../views/LimitManagement/WLAddWithdrawLimit.jsx";
import WLAddWithdrawalCount from "../views/LimitManagement/WLAddWithdrawalCount.jsx";
import SLSendLimit from "../views/LimitManagement/SLSendLimit.jsx";
import AddLoadLimit from "../views/LimitManagement/AddLoadLimit.jsx";
import AddLoadCount from "../views/LimitManagement/AddLoadCount.jsx";
import UWLAddWithdrawLimit from "../views/LimitManagement/UWLAddWithdrawLimit.jsx";
import UWLAddWithdrawalCount from "../views/LimitManagement/UWLAddWithdrawalCount.jsx";
import AddLoyaltyService from "../views/WalletManagement/AddLoyaltyService";
import AddNewKycConfigration from "../views/KycManagement/AddNewKycConfigration.jsx";
import KycConfigration from "../views/KycManagement/KycConfigration.jsx";
import KycReport from "../views/KycManagement/KycReport.jsx";
import KybReport from "../views/KycManagement/KybReport.jsx";
import FeeManagement from "../views/FeeManagement/FeeManagement.jsx";
import MerchantInvoice from "../views/InvoiceManagement/MerchantInvoice";
import MerchantConfiguration from "../views/InvoiceManagement/MerchantConfiguration";
import GetInvoiceDetails from "../views/InvoiceManagement/GetInvoiceDetails";
import WalletDashboard from "../views/WalletManagement/WalletDashboard";
import GetActionDetails from "../views/InvoiceManagement/GetActionDetails";
import GetRegenerateInVoice from "../views/InvoiceManagement/GetRegenerateInVoice";
import Transaction from "../views/GateWayService/Transaction";
import GetWayTransactionDetails from "../views/GateWayService/GetWayTransactionDetails.jsx";
import PartnerViewKycDetails from "../views/AdminKycManagement/PartnerViewKycDetails.jsx";
import FeeWallet from "../views/AccountManagement/FeeWallet.jsx";
import Configuration from "../views/Settings/Configuration.jsx";
import ModuleAllocation from "../views/Settings/ModuleAllocation.jsx";
import WalletOwnerBanks from "../views/Settings/WalletOwnerBanks.jsx";
import AddBankDetails from "../views/Settings/AddBankDetails.jsx";
import AddNewFeeWallet from "../views/AccountManagement/AddNewFeeWallet.jsx";
import AdNewConfiguration from "../views/Settings/addNewConfiguration";
import EditConfiguration from "../views/Settings/EditConfiguration";
import PartnerModuleAllocation from "../views/Settings/PartnerModuleAllocation";
// SuperAdmin
import walletOwnerManagement from "../views/MyAccounts/walletOwnerManagement.jsx";
import AdminBusinessNatureManagement from "../views/AdminWalletOwnerManagement/AdminBusinessNatureManagement.jsx";
// import AdminBusinessNatureManagement1 from "../views/AdminWalletOwnerManagement/AdminBusinessNatureManagement1.jsx";
import AdminCreateWalletOwner from "../views/AdminWalletOwnerManagement/AdminCreateWalletOwner.jsx";
import AdminEntityTypeManagement from "../views/AdminWalletOwnerManagement/AdminEntityTypeManagement.jsx";
import AdminRoleManagement from "../views/AdminWalletOwnerManagement/AdminRoleManagement.jsx";
import AdminWalletOwnerSettings from "../views/AdminWalletOwnerManagement/AdminWalletOwnerSettings.jsx";
import AdminAddWalletOwner from "../views/AdminWalletOwnerManagement/AdminAddWalletOwner.jsx";
import AdminAddNewBusinessNature from "../views/AdminWalletOwnerManagement/AdminAddNewBusinessNature.jsx";
import AdminMappingBusinessNature from "../views/AdminWalletOwnerManagement/AdminMappingBusinessNature.jsx";
import AdminMappingEntityType from "../views/AdminWalletOwnerManagement/AdminMappingEntityType.jsx";
import AdminMappingRole from "../views/AdminWalletOwnerManagement/AdminMappingRole.jsx";
import adminGatewayManagement from "../views/MyAccounts/adminGatewayManagement";
import AdminGatewayManagement from "../views/AdminGatewayManagement/AdminGatewayManagement.jsx";
import AdminAddGatewayManagement from "../views/AdminGatewayManagement/AdminAddGatewayManagement.jsx";
import adminFraudRiskManagement from "../views/MyAccounts/adminFraudRiskManagement.jsx";
import AdminRiskRuleManagement from "../views/AdminFraudRiskManagement/AdminRiskRuleManagement.jsx";
import AdminRiskRuleMapping from "../views/AdminFraudRiskManagement/AdminRiskRuleMapping.jsx";
import AdminAddRiskRuleMapping from "../views/AdminFraudRiskManagement/AdminAddRiskRuleMapping.jsx";
import adminCurrencyManagement from "../views/MyAccounts/adminCurrencyManagement.jsx";
import AdminCurrencyMaster from "../views/AdminCurrencyManagement/AdminCurrencyMaster.jsx";
import AdminCurrencyMapping from "../views/AdminCurrencyManagement/AdminCurrencyMapping.jsx";
import adminWalletManagement from "../views/MyAccounts/adminWalletManagement.jsx";
import AdminWalletTransaction from "../views/AdminWalletManagement/AdminWalletTransaction.jsx";
import adminKycManagement from "../views/MyAccounts/adminKycManagement.jsx";
import AdminCreateProofType from "../views/AdminKycManagement/AdminCreateProofType.jsx";
import AdminCreateDocumentType from "../views/AdminKycManagement/AdminCreateDocumentType.jsx";
import AdminKycMapping from "../views/AdminKycManagement/AdminKycMapping.jsx";
import AdminKycReport from "../views/AdminKycManagement/AdminKycReport.jsx";
import AdminKybReport from "../views/AdminKycManagement/AdminKybReport.jsx";
import adminFeeMaster from "../views/MyAccounts/adminFeeMaster.jsx";
import AdminFeeMapping from "../views/AdminFeeMaster/AdminFeeMapping.jsx";
import AdminFeeMaster from "../views/AdminFeeMaster/AdminFeeMaster.jsx";
import AdminLoyaltyManagement from "../views/AdminWalletOwnerManagement/AdminLoyaltyManagement.jsx";
import AdminWalletOwnerView from "../views/AdminWalletOwnerManagement/AdminWalletOwnerView.jsx";
import AdminWalletOwnerUpdate from "../views/AdminWalletOwnerManagement/AdminWalletOwnerUpdate.jsx";
import AdminModuleAllocation from "../views/AdminWalletOwnerManagement/AdminModuleAllocation.jsx";
import AdminViewKycDetails from "../views/AdminKycManagement/AdminViewKycDetails.jsx";
import getKybDetails from "../views/KycManagement/getKybDetails";
import adminSetting from "../views/MyAccounts/adminSetting.jsx";
import AdminSetting from "../views/AdminSettings/AdminSetting.jsx";
import AdminViewKybDetails from "../views/AdminKycManagement/AdminViewKybDetails.jsx";
import editKycConfiguration from "../views/KycManagement/editKycConfiguration.jsx";
import userManagement from "../views/MyAccounts/userManagement.jsx";
import backOffice from "../views/UserManagement/backOffice.jsx";
import AddUserManagement from "../views/UserManagement/AddUserManagement.jsx";
import MemberMapping from "../views/MemberMapping/MemberMapping.jsx";
import UserManagementAdmin from "../views/MyAccounts/userManagementAdmin.jsx";

import SettlementManagement from "../views/MyAccounts/settlementManagement.jsx";
import MerchantWireReport from "../views/SettlementManagement/MerchantWireReport.jsx"
import ManualSettlement from "../views/SettlementManagement/ManualSettlement.jsx"
import ChargeMaster from "../views/SettlementManagement/ChargeMaster.jsx"
import VoucherWireManager from "../views/SettlementManagement/VoucherWireManager.jsx"
import GenerateMerchantWireReport from "../views/SettlementManagement/GenerateMerchantWireReport.jsx"
import dealerProfile from "../views/MyAccounts/dealerProfile.jsx";
import DealerProfile from "../views/DealerProfile/DealerProfile.jsx";
import dealerDsrManagement from "../views/MyAccounts/dealerDsrManagement.jsx";
import DealerDsrMaster from "../views/DealerDsrManagement/DealerDsrMaster.jsx";
import DealerDsrTransaction from "../views/DealerDsrManagement/DealerDsrTransaction.jsx";
import DealerAddNewUser from "../views/DealerDsrManagement/DealerAddNewUser.jsx"
import DealerAddLimit from "../views/DealerDsrManagement/DealerAddLimit.jsx";
import DealerAddNewDsrLimit from "../views/DealerDsrManagement/DealerAddNewDsrLimit.jsx";
import DealerUploadDsrLimit from "../views/DealerDsrManagement/DealerUploadDsrLimit.jsx";
import DealerViewDsrList from "../views/DealerDsrManagement/DealerViewDsrList.jsx"
import GatewayAccountCharge from "../views/SettlementManagement/GatewayAccountCharge.jsx";
import dealerCashLifting from "../views/MyAccounts/dealerCashLifting.jsx";
import DealerCashLifting from "../views/DealerCashLifting/DealerCashLifting.jsx";
import dealerWithdrawEMoney from "../views/MyAccounts/dealerWithdrawEMoney.jsx";
import DealerWithdrawEMoney from "../views/DealerWithdrawEMoney/DealerWithdrawEMoney.jsx";
import dealerPendingRequest from "../views/MyAccounts/dealerPendingRequest.jsx";
import DealerPendingRequest from "../views/DealerPendingRequest/DealerPendingRequest.jsx";
import dealerWalletManagement from "../views/MyAccounts/dealerWalletManagement.jsx";
import DealerWalletTransaction from "../views/DealerWalletManagement/DealerWalletTransaction.jsx";
import DealerSummaryReport from "../views/DealerWalletManagement/DealerSummaryReport.jsx";
import DealerFeeReport from "../views/DealerWalletManagement/DealerFeeReport.jsx";
import dealerUserManagement from "../views/MyAccounts/dealerUserManagement.jsx";
import DealerBackOffice from "../views/DealerUserManagement/DealerBackOffice.jsx";
import DealerAgentMaster from "../views/DealerAgentMaster/DealerAgentMaster.jsx";
import dealerAgentMaster from "../views/MyAccounts/dealerAgentMaster.jsx";
import DealerAddNewDsr from "../views/DealerAgentMaster/DealerAddNewDsr.jsx";
import BankMasterDashboard from "../views/BankModule/BankMaster/BankMasterDashboard.jsx";
import CashLiftingDashboard from "../views/BankModule/CashLifting/CashLiftingDashboard.jsx";
import UserManagementDashboard from "../views/BankModule/UserManagement/UserManagementDashboard.jsx";
import WithDrawEMoneyDashboard from "../views/BankModule/WithDrawEMoney/WithDrawEMoneyDashboard.jsx";
import BankMaster from "../views/BankModule/BankMaster/BankMaster.jsx";
import BankCashLifting from "../views/BankModule/CashLifting/BankCashLifting.jsx";
import BankWithdrawEMoney from "../views/BankModule/WithDrawEMoney/BankWithdrawEMoney.jsx";
import BankUserManagement from "../views/BankModule/UserManagement/BankUserManagement.jsx";


import AddEditChargeMaster from "../views/SettlementManagement/AddEditChargeMaster.jsx";
import AddMerchantCharges from "../views/SettlementManagement/AddMerchantCharges.jsx";
import DealerMultipleDsrMapping from "../views/DealerAgentMaster/DealerMultipleDsrMapping.jsx";
import DealerAgentUpload from "../views/DealerAgentMaster/DealerAgentUpload.jsx";
import DealerViewUserMaster from "../views/DealerAgentMaster/DealerViewUserMaster.jsx";
import cashLifting from "../views/MyAccounts/cashLifting.jsx";
import CashLifting from "../views/CashLifting/CashLifting.jsx"
import withdrawEMoney from "../views/MyAccounts/withdrwaEMoney.jsx";
import WithdrawEMoney from "../views/WithdrawEMoney/WithdrawMoney.jsx"
import agentDealerMapping from "../views/MyAccounts/agentDealerMapping.jsx";
import AgentDealerMapping from "../views/AgentDealerMapping/AgentDealerMapping.jsx"
import DealerMultipleMapping from "../views/AgentDealerMapping/DealerMultipleMapping.jsx";
import AgentViewDealer from "../views/AgentDealerMapping/AgentViewDealer.jsx";
import TwoFaAuthentication from "../views/AccountManagement/TwoFaAuthentication.jsx";
import EnableIpWhitelist from '../views/AccountManagement/EnableIPWhitelist.jsx'
import AdminAddModule from "../views/AdminWalletOwnerManagement/AdminAddModule.jsx";
import AdminAddSubModule from "../views/AdminWalletOwnerManagement/AdminAddSubModule.jsx";
import CountrySettings from "../views/AdminSettings/CountrySettings.jsx";
import AdminBankMaster from "../views/AdminSettings/AdminBankMaster.jsx"
import AdminMappingCountry from "../views/AdminSettings/AdminMappingCountry.jsx";
import AdminMappingBank from "../views/AdminSettings/AdminMappingBank.jsx";
import AdminLanguageMaster from "../views/AdminSettings/AdminLanguageMaster.jsx";
import AdminMappingLanguage from "../views/AdminSettings/AdminMappingLanguage.jsx";
import AdminTransferType from "../views/AdminSettings/AdminTransferType.jsx";
import AdminTransferTypeMapping from "../views/AdminSettings/AdminTransferTypeMapping.jsx";
import AdminMappingAccountType from "../views/AdminSettings/AdminMappingAccountType.jsx";
import AccountTypeAdmin from "../views/AdminSettings/AccountTypeAdmin.jsx";
import AdminBankType from "../views/AdminSettings/AdminBankType.jsx";
import AdminAccountTypeMapping from "../views/AdminSettings/AdminAccountTypeMapping.jsx";
import PartnerBankMaster from "../views/Settings/PartnerBankMaster.jsx";
import ActivityTracker from "../views/Settings/ActivityTracker.jsx";
import IpWhitelisting from '../views/Settings/Ipwhitelisting.jsx';
import Refund from "../views/GateWayService/Refund.jsx";
import ViewReversal from "../views/GateWayService/ViewReversal.jsx";
// import AdminRefund from "../views/AdminWalletManagement/AdminRefund.jsx";
import AdminRefund from "../views/AdminTransactionManagement/AdminRefund.jsx"
import AdminPushNotification from "../views/AdminSettings/AdminPushNotification.jsx";
// import adminTransactionManagement from "./sidebarRoutes/adminTransactionManagement.js";
import adminTransactionManagement from "../views/MyAccounts/adminTransactionManagement.jsx";
import AdminTransaction from "../views/AdminTransactionManagement/AdminTransaction.jsx";

// THIS IS FOR ADMIN CONFIGURATION---------------------------------------------------------------------------
import AdminConfiguration from "../views/AdminWalletManagement/AdminConfiguration.jsx";
import AdminAddNewConfiguration from "../views/AdminWalletManagement/AdminAddNewConfiguration.jsx";
import AdminViewConfiguration from "../views/AdminWalletManagement/AdminViewConfiguration.jsx";
import AdminUpdateConfiguration from "../views/AdminWalletManagement/AdminUpdateConfiguration.jsx";
import AdminCommonCongigurationList from "../views/AdminWalletManagement/AdminCommonCongigurationList";
import gatewayManagementAdmin from "../views/MyAccounts/gatewayManagementAdmin.jsx";
import GatewayManagementAdmin from "../views/AdminGatewayManagementNew/GatewayManagementAdmin.jsx";
import AdminBusinessNatureSubCategory from "../views/AdminWalletOwnerManagement/AdminBusinessNatureSubCategory.jsx";
import KycLevel from "../views/KycManagement/KycLevel.jsx";

import AdminSMSProvider from "../views/AdminSettings/AdminSMSProvider.jsx";

import AdminMemberMapping from "../views/AdminGatewayManagementNew/AdminMemberMapping.jsx";
import ActivityTrackerAdmin from "../views/AdminSettings/ActivityTrackerAdmin.jsx";
import backOfficeAdmin from "../views/UserManagementAdmin/backOfficeAdmin.jsx";
import AdminUserMgmt from "../views/AdminUserManagementsData/AdminUserMgmt.jsx";
import AdminUserManagement from "../views/MyAccounts/adminUserManagement.jsx";
import AdminModuleAllocationData from "../views/AdminSettings/AdminModuleAllocationData.jsx";
import ModuleAllocationAdmin from "../views/UserManagementAdmin/moduleAllocationAdmin.jsx";
import AddSubModulesAdmin from "../views/UserManagementAdmin/AddSubModulesAdmin.jsx";
import AdminModuleAllocationList from "../views/AdminSettings/AdminModuleAllocationList.jsx"
import AdminIBNProviderMgmt from "../views/AdminWalletOwnerManagement/AdminIBNProviderMgmt.jsx";
import AdminIBNProviderMapping from "../views/AdminWalletOwnerManagement/AdminIBNProviderMapping.jsx";
import CustomerBanks from "../views/AccountManagement/CustomerBanks.jsx";
import AddCustomerBankDetails from "../views/AccountManagement/AddCustomerBankDetails.jsx";
import SettlementReport from "../views/WalletManagement/SettlementReport.jsx";
import FeeMarkup from '../views/FeeManagement/FeeMarkup.jsx';
import ChargeBack from '../views/WalletManagement/Chargeback.jsx'
import GenerateLink from '../views/AccountManagement/GenerateLink.jsx'
import Reconciliation from '../views/WalletManagement/Reconciliation.jsx'
// import AdminMemberMapping from "../views/AdminGatewayManagementNew/AdminMemberMapping.jsx";

//-----------------------------------------------------------------------------------------------------------

var dashRoutes = [
  {
    path: "/index/homepage",
    name: "Dashboard",
    icon: "Dashboard",
    component: MainDashboard,
    logoName: "Dashboard",
  },

  // Account Management
  {
    path: "/index/account-management",
    name: "Dashboard",
    icon: "my-accounts",
    component: MyAccounts,
    logoName: "MyAccounts",
  },

  {
    path: "/index/customer-master",
    name: "Customer Master",
    icon: "my-accounts",
    component: CustomerMaster,
  },


  {
    path: "/index/customer-bank",
    name: "Customer Bank",
    icon: "my-accounts",
    component: CustomerBanks,
  },
  {
    path: "/index/addCustomerBankDetails",
    name: "Add Customer Bank Details",
    component: AddCustomerBankDetails,
  },
  {
    path: "/index/two-fa-authentication",
    name: "Two Factor Authentication",
    icon: "my-accounts",
    component: TwoFaAuthentication,
  },
  {
    path: "/index/merchantconfiguration",
    name: "Merchant Configuration",
    icon: "my-accounts",
    component: EnableIpWhitelist,
  },
   {
    path: "/index/generatelink",
    name: "Generate Link",
    icon: "my-accounts",
    component:GenerateLink,
  },
  {
    // path: "/index/inidividualentity",
    // name: "Add Indiividual Entity",
    path: "/index/individualentity",
    name: "Add Individual Entity",
    icon: "my-accounts",
    component: indvidualEntity,
  },
  {
    path: "/index/legalEntity",
    name: "Add Legal Entity",
    component: LegalEntity,
  },

  {
    path: "/index/custManualDeposit",
    name: "Manual Deposit",
    component: ManualDeposit,
  },
  {
    path: "/index/unlockCustomerAccount",
    name: "Unlock Customer Account",
    component: UnlockCustomerAccount,
  },

  {
    // path: "/index/create-wallet",
    path: "/index/customer-wallet",
    name: "Customer Wallet",
    component: CreateWallet,
  },

  {
    path: "/index/addNewCustomerWallet",
    name: "Add New Customer Wallet",
    component: AddNewCustomerWallet,
  },
  {
    path: "/index/createFeeWallet",
    name: "Create Fee Wallet",
    component: CreateFeeWallet,
  },
  {
    path: "/index/addNewFeeWallet",
    name: "Add New Fee Wallet",
    component: AddNewFeeWallet,
  },
  {
    path: "/index/manual-otp-request",
    name: "Manual OTP Request",
    component: ManualOTP,
  },
  {
    path: "/index/manual-upgrade-request",
    name: "Manual Upgrade Request",
    component: ManualUpgrade,
  },
  {
    path: "/index/actionCustomerMaster",
    // name: "Action Customer Master",
    name: "Block Operation",
    component: ActionCustomerMaster,
  },
  {
    path: "/index/getCustomerDetails",
    // name: "Get Customer Details",
    name: "Customer Details",
    component: GetCustomerDetails,
  },

  {
    path: "/index/fee-wallet",
    // name: "Get Customer Details",
    name: "Fee Wallet",
    component: FeeWallet,
  },

  //setting

  ///index/settings
  {
    path: "/index/settings",
    // name: "Get Customer Details",
    name: "Dashboard",
    component: Settings,
  },

  {
    path: "/index/configration",
    // name: "Get Customer Details",
    name: "Configuration",
    component: Configuration,
  },

  {
    path: "/index/moduleAllocation",
    // name: "Get Customer Details",
    name: "Module Allocation",
    component: ModuleAllocation,
  },

  {
    path: "/index/wallet-owner-bank",
    // name: "Get Customer Details",
    name: "Wallet Owner Banks",
    component: WalletOwnerBanks,
  },

  {
    path: "/index/addBankDetails",
    // name: "Get Customer Details",
    name: "Add Bank Details",
    component: AddBankDetails,
  },

  {
    path: "/index/getViewConfigurationList",
    // name: "Get Customer Details",
    name: "View Configuration List",
    component: ViewConfiguration,
  },
  {
    path: "/index/addNotification",

    name: "Notification",
    component: addNotification
  },

  {
    path: "/index/getEditConfigurationList",
    // name: "Get Customer Details",
    name: "Edit Configuration List",
    component: EditConfiguration,
  },

  {
    path: "/index/getCommonCongigurationList",
    // name: "Get Customer Details",
    name: "Common Configuration List",
    component: CommonConfiguration,
  },
  {
    path: "/index/partnerModuleAllocation",
    // name: "Get Customer Details",
    name: "Partner Module Allocation",
    component: PartnerModuleAllocation,
  },
  {
    path: "/index/PartnerBankMaster",
    // name: "Get Customer Details",
    name: "Bank Master",
    component: PartnerBankMaster,
  },
  {
    path: "/index/ActivityTracker",
    name: "Activity Tracker",
    component: ActivityTracker,
  },
  {
    path: "/index/ipWhitelisting",
    name: "Activity Tracker",
    component: IpWhitelisting,
  },





  // Fraud & Risk Management

  {
    path: "/index/fraud&risk-management",
    name: "Dashboard",
    component: FraudRiskManagement,
  },

  {
    path: "/index/risk-rules",
    name: "Risk Rule",
    component: RiskRule,
  },
  {
    path: "/index/rule-mapping",
    name: "Rule Mapping",
    component: RuleMapping,
  },
  {
    path: "/index/block-country",
    name: "Block Country",
    component: BlockCountry,
  },
  {
    path: "/index/allow-country",
    name: "Allow Country",
    component: AllowCountry,
  },

  // Voucher Management

  {
    path: "/index/voucher-management",
    name: "Dashboard",
    component: voucherManagement,
  },

  {
    path: "/index/voucher-mapping",
    name: "Voucher Mapping",
    component: VoucherMapping,
  },

  {
    path: "/index/voucher-transaction",
    name: "Voucher Transaction",
    component: VoucherTransaction,
  },

  {
    path: "/index/vouchers",
    name: "Vouchers",
    component: Vouchers,
  },

  {
    path: "/index/redeem",
    name: "Redeem",
    component: Redeem,
  },

  {
    path: "/index/getVoucherTransactionDetails",
    // name: "Get Voucher Transaction Details",
    name: "Voucher Transaction Details",
    component: GetVoucherTransactionDetails,
  },

  {
    path: "/index/redeemDetails",
    name: "Redeem Details",
    component: RedeemDetails,
  },
  {
    path: "/index/voucherDetails",
    name: "Voucher Details",
    component: VoucherDetails,
  },

  // Currency Management

  {
    path: "/index/currency-management",
    name: "Dashboard",
    component: CurrencyManagement,
  },
  {
    path: "/index/currency-master",
    name: "Currency Master",
    component: CurrenMaster,
  },

  {
    path: "/index/conversion-rate",
    name: "Conversion Rate",
    component: ConversionRate,
  },

  // Wallet Management

  {
    path: "/index/wallet-management",
    name: "Dashboard",
    component: WalletManagement,
  },

  {
    path: "/index/wallet-dashboard",
    name: "Account Dashboard",
    component: WalletDashboard,
  },
  {
    path: "/index/wallet-transaction",
    name: "Transaction",
    component: WalletTransaction,
  },
  {
    path: "/index/settlement-report",
    name: "Settlement Report",
    component: SettlementReport,
  },
  {
    path: "/index/chargeback",
    name: "Chargeback",
    component:ChargeBack,
  },
  {
    path: "/index/reconciliation",
    name: "Reconciliation",
    component:Reconciliation,
  },
  {
    path: "/index/operation-logs",
    name: "Fee Transaction",
    component: OperationLogs,
  },
  {
    path: "/index/loyal-points",
    name: "Loyalty Points",
    component: LoyaltyPointsA,
  },
  {
    path: "/index/summary-report",
    name: "Summary Report",
    component: SummaryReport,
  },
  {
    path: "/index/Refund",
    name: "Refund",
    component: Refund,
  },

  {
    path: "/index/fee-report",
    name: "Fee Report",
    component: FeeReport,
  },

  {
    path: "/index/add-loyalty-service",
    // name: "Add Loyalty Service",
    name: "Add Loyalty Point",
    component: AddLoyaltyService,
  },

  // Limit Management

  {
    path: "/index/limit-management",
    name: "Dashboard",
    component: LimitManagement,
  },
  {
    path: "/index/withdraw-limit",
    name: "Withdraw Limit",
    component: WithdrawLimit,
  },

  {
    path: "/index/WL-addwithdraw-limit",
    name: "Add Withdraw Limit",
    component: WLAddWithdrawLimit,
  },

  {
    path: "/index/WL-addwithdrawal-count",
    name: "Add Withdrawal Count",
    component: WLAddWithdrawalCount,
  },

  {
    path: "/index/user-withdraw-limit",
    name: "User Withdraw Limit",
    component: UserWithdrawLimit,
  },

  {
    path: "/index/UWL-addwithdraw-limit",
    name: "Add New Withdraw Limit",
    component: UWLAddWithdrawLimit,
  },
  {
    path: "/index/UWL-addwithdrawal-count",
    name: "Add Withdrawal Count",
    component: UWLAddWithdrawalCount,
  },
  {
    path: "/index/load-limit",
    name: "Load Limit",
    component: LoadLimit,
  },
  {
    path: "/index/send-limit",
    name: "Send Limit",
    component: SendLimit,
  },

  {
    path: "/index/add-load-limit",
    name: "Add Load Limit",
    component: AddLoadLimit,
  },

  {
    path: "/index/add-load-count",
    name: "Add Load Count",
    component: AddLoadCount,
  },

  {
    path: "/index/SL-send-limit",
    name: "Send Limit2",
    component: SLSendLimit,
  },

  // KYC Management

  {
    path: "/index/kyc-management",
    name: "Dashboard",
    component: KycManagement,
  },
  {
    path: "/index/kyc-configuration",
    name: "KYC Configuration",
    component: KycConfigration,
  },
  {
    path: "/index/kyc-report",
    name: "KYC Report",
    component: KycReport,
  },
  {
    path: "/index/kyb-report",
    name: "KYB Report",
    component: KybReport,
  },
  {
    path: "/index/add-new-kyc-configuration",
    name: "Add Kyc Configuration",
    component: AddNewKycConfigration,
  },
  {
    path: "/index/edit-kyc-configuration",
    name: "Edit Kyc Configuration",
    component: editKycConfiguration,
  },
  {
    path: "/index/getKybDetails",
    name: "KYB Details",
    component: getKybDetails,
  },
  {
    path: "/index/KycLevel",
    name: "KYC Level",
    component: KycLevel,
  },

  // Fee Management

  {
    path: "/index/fee-management",
    name: "Dashboard",
    component: FeeManagementService,
  },
  {
    path: "/index/fee",
    name: "Fee Management",
    component: FeeManagement,
  },
  {
    path: "/index/feemarkup",
    name: "Fee Markup",
    component: FeeMarkup,
  },

  // Invoice

  {
    path: "/index/invoice-management",
    name: "Dashboard",
    component: InvoiceManagement,
  },

  {
    path: "/index/merchantInvoice",
    name: "Merchant Invoice",
    component: MerchantInvoice,
  },

  {
    path: "/index/merchantConfiguration",
    name: "Merchant Configuration",
    component: MerchantConfiguration,
  },

  {
    path: "/index/getInvoiceDetails",
    name: "Get Invoice Details",
    component: GetInvoiceDetails,
  },
  {
    path: "/index/getRegenerateInVoice",
    name: "Get Regenerate InVoice",
    component: GetRegenerateInVoice,
  },

  {
    path: "/index/getActionDetails",
    name: "Get Action Details",
    component: GetActionDetails,
  },

  //Gate Way Service

  {
    // path: "/index/gateway-management",
    path: "/index/transaction-management",
    name: "Dashboard",
    component: GateWayServiceManagement,
  },
  {
    path: "/index/transaction",
    name: "Transaction",
    component: Transaction,
  },
  // {
  //   path: "/index/Refund",
  //   name: "Refund",
  //   component: Refund,
  // },
  {
    path: "/index/ViewReversal",
    name: "Reversal Information",
    component: ViewReversal,
  },

  {
    // path: "/index/getWatTransactionDetails",
    path: "/index/getTransactionDetails",
    // name: "GetWay Transaction Details",
    name: "Transaction Details",
    component: GetWayTransactionDetails,
  },

  {
    path: "/index/PartnerViewKycDetails",
    name: "KYC Details",
    component: PartnerViewKycDetails,
  },

  {
    path: "/index/AddNewConfiguration",
    name: "Add Configuration",
    component: AdNewConfiguration,
  },

  // Fee Management

  {
    path: "/index/user-management",
    name: "Dashboard",
    component: userManagement,
  },
  {
    path: "/index/BackOffice",
    name: "Back Office",
    component: backOffice,
  },
  {
    path: "/index/adduserManagement",
    name: "Add User Management",
    component: AddUserManagement,
  },

  //Admin-User Mgmt
  {
    path: "/index/user-managementAdmin",
    name: "Dashboard",
    component: UserManagementAdmin,
  },
  {
    path: "/index/BackOfficeAdmin",
    name: "Back Office",
    component: backOfficeAdmin,
  },
  {
    path: "/index/moduleAllocationAdmin",
    name: "Add Module",
    component: ModuleAllocationAdmin,
  },
  {
    path: "/index/AddSubModulesAdmin",
    name: "Add SubModule",
    component: AddSubModulesAdmin
  },
  // {
  //   path: "/index/adduserManagement",
  //   name: " Add User Management",
  //   component: AddUserManagement,
  // },

  //cash lifting


  {
    path: "/index/cash-Lifting",
    name: "Dashboard",
    component: cashLifting
  },
  {
    path: "/index/Cash-LiftingP",
    name: "Cash Lifting",
    component: CashLifting
  },
  ///dealer cash lifting
  {
    path: "/index/dealerCashLifting",
    name: "Dashboard",
    component: dealerCashLifting
  },
  {
    path: "/index/cashLifting",
    name: "Cash Lifting",
    component: DealerCashLifting
  },

  //withdraw e money
  {
    path: "/index/withdraw-money",
    name: "Dashboard",
    component: withdrawEMoney
  },
  {
    path: "/index/withdrawMoney",
    name: "Withdraw E-Money",
    component: WithdrawEMoney
  },
  //Partner Agent Dealer Mapping
  {
    path: "/index/agent-Dealer-Map",
    name: "Dashboard",
    component: agentDealerMapping
  },
  {
    path: "/index/Agent-DealerMap",
    name: "Mapping Dealer",
    component: AgentDealerMapping
  },
  {
    path: "/index/DealerMultipleMapping",
    name: "Mapping Dealer",
    component: DealerMultipleMapping
  },
  {
    path: "/index/AgentViewDealer",
    name: "Report table",
    component: AgentViewDealer
  },

  // settlement management

  {
    path: "/index/settlement-management",
    name: "Dashboard",
    component: SettlementManagement,
  },
  {
    path: "/index/merchantWireReport",
    name: "Merchant Wire Report",
    component: MerchantWireReport,
  },

  {
    path: "/index/addMerchantCharge",
    name: "Add Merchant Charge",
    component: AddMerchantCharges,
  },

  {
    path: "/index/manualSettlement",
    name: "Manual Settlement",
    component: ManualSettlement,
  },

  {
    path: "/index/chargeMaster",
    name: "Charge Master",
    component: ChargeMaster,
  },

  {
    path: "/index/gatewayAccountCharge",
    name: "Gateway Account Charge",
    component: GatewayAccountCharge,
  },

  {
    path: "/index/voucherWireManager",
    name: "Voucher Wire Manager",
    component: VoucherWireManager,
  },

  {
    path: "/index/generateMerchantWireReport",
    name: "Generate Merchant Wire Report",
    component: GenerateMerchantWireReport,
  },
  {
    path: "/index/addEditChargeMaster",
    name: "Charge Master",
    component: AddEditChargeMaster,
  },


  // SuperAdmin
  {
    path: "/index/walletOwnerManagement",
    component: walletOwnerManagement,
  },
  // {
  //   path: "/index/business-nature-management",
  //   component: AdminBusinessNatureManagement,
  // },
  {
    path: "/index/business-nature-management",
    component: AdminBusinessNatureManagement,
  },
  {
    path: "/index/AdminBusinessNatureSubCategory",
    name: "Business Nature Sub-Category",
    component: AdminBusinessNatureSubCategory,
  },
  {
    path: "/index/create-wallet-owner",
    component: AdminCreateWalletOwner,
  },
  {
    path: "/index/entity-type-management",
    component: AdminEntityTypeManagement,
  },
  {
    path: "/index/role-management",
    component: AdminRoleManagement,
  },
  {
    path: "/index/wallet-owner-settings",
    name: "Add Wallet Owner",
    icon: "",
    component: AdminWalletOwnerSettings,
  },
  {
    path: "/index/adminAddModule",
    name: "Add Module",
    icon: "",
    component: AdminAddModule,
  },
  {
    path: "/index/adminAddSubModule",
    name: "Add Sub Module",
    icon: "",
    component: AdminAddSubModule,
  },
  {
    path: "/index/wallet-owner-settings-view",
    name: "View Owner Settings",
    component: AdminWalletOwnerView,
  },
  {
    path: "/index/wallet-owner-settings-update",
    name: "Update Owner Settings",
    component: AdminWalletOwnerUpdate,
  },
  {
    path: "/index/adminModuleAllocation",
    name: "Partner Module Allocation",
    component: AdminModuleAllocation,
  },
  {
    path: "/index/loyalty-management",
    name: "Loyal Point Management",
    component: AdminLoyaltyManagement,
  },
  {
    path: "/index/add-wallet-owner",
    name: "Add Wallet Owner",
    icon: "",
    component: AdminAddWalletOwner,
  },
  {
    path: "/index/add-new-business-nature",
    name: "Add New Business Nature",
    icon: "",
    component: AdminAddNewBusinessNature,
  },
  {
    path: "/index/mapping-business-nature",
    name: "Mapping Business Nature",
    icon: "",
    component: AdminMappingBusinessNature,
  },
  {
    path: "/index/mapping-entity-type",
    component: AdminMappingEntityType,
  },
  {
    path: "/index/mapping-role",
    component: AdminMappingRole,
  },
  {
    path: "/index/AdminGateway-Management",
    component: adminGatewayManagement,
  },
  {
    path: "/index/gatewayManagement",
    component: AdminGatewayManagement,
  },
  {
    path: "/index/AdminFraudRisk-Management",
    name: "Dashboard",
    component: adminFraudRiskManagement,
  },
  {
    path: "/index/RiskRule",
    name: "Risk Rule",
    component: AdminRiskRuleManagement,
  },
  {
    path: "/index/RiskRuleMapping",
    name: "Risk Rule Mapping",
    component: AdminRiskRuleMapping,
  },
  {
    path: "/index/AdminCurrency-Management",
    name: "Dasboard",
    component: adminCurrencyManagement,
  },
  {
    path: "/index/CurrencyMaster",
    name: "Currency Master",
    component: AdminCurrencyMaster,
  },
  {
    path: "/index/CurrencyMapping",
    name: "Currency Mapping",
    component: AdminCurrencyMapping,
  },
  {
    path: "/index/AdminWallet-Management",
    name: "Dashboard",
    component: adminWalletManagement,
  },
  {
    path: "/index/WalletTransaction",
    name: "Wallet Transactions",
    component: AdminWalletTransaction,
  },
  // ADMIN CONFIGURATION---------------------
  {
    path: "/index/AdminConfiguration",
    name: "Configuration",
    component: AdminConfiguration,
  },
  {
    path: "/index/AdminAddNewConfiguration",
    name: "Add Configuration",
    component: AdminAddNewConfiguration,
  },
  {
    path: "/index/AdminUpdateConfiguration",
    name: "Update Configuration",
    component: AdminUpdateConfiguration,
  },
  {
    path: "/index/AdminViewConfiguration",
    name: "View Configuration",
    component: AdminViewConfiguration,
  },
  {
    path: "/index/AdminCommonCongigurationList",
    name: "Common Configuration",
    component: AdminCommonCongigurationList,
  },
  //-----------------------------------------------------
  {
    path: "/index/AdminTransaction-Management",
    name: "Dashboard",
    component: adminTransactionManagement,
  },
  {
    path: "/index/AdminRefund",
    name: "Refund",
    component: AdminRefund
  },
  {
    path: "/index/AdminTransaction",
    name: "Transaction",
    component: AdminTransaction
  },

  {
    path: "/index/AdminTransaction-Management",
    name: "Dashboard",
    component: AdminUserManagement,
  },
  {
    path: "/index/AdminUserMgmt",
    name: "Transaction",
    component: AdminUserMgmt
  },


  {
    path: "/index/AdminKyc-Management",
    name: "Dashboard",
    component: adminKycManagement,
  },
  {
    path: "/index/CreateProofType",
    name: "Create Proof Type",
    component: AdminCreateProofType,
  },
  {
    path: "/index/CreateDocumentType",
    name: "Create Document Type",
    component: AdminCreateDocumentType,
  },
  {
    path: "/index/KycMapping",
    name: "KYC Mapping",
    component: AdminKycMapping,
  },
  {
    path: "/index/KycReport",
    name: "KYC Report",
    component: AdminKycReport,
  },
  {
    path: "/index/KybReport",
    name: "KYB Report",
    component: AdminKybReport,
  },
  {
    path: "/index/AdminFee-Master",
    name: "Dasboard",
    component: adminFeeMaster,
  },
  {
    path: "/index/FeeMaster",
    name: "Fee Master",
    component: AdminFeeMaster,
  },
  {
    path: "/index/FeeMapping",
    name: "Fee Mapping",
    component: AdminFeeMapping,
  },
  // SuperAdmin
  {
    path: "/index/walletOwnerManagement",
    name: "Dashboard",
    component: walletOwnerManagement,
  },
  {
    path: "/index/business-nature-management",
    name: "Business Nature Management",
    component: AdminBusinessNatureManagement,
  },
  {
    path: "/index/create-wallet-owner",
    name: "Create Owner",
    component: AdminCreateWalletOwner,
  },
  {
    path: "/index/AdminIBNProviderManagement",
    name: "IBAN Provider Management",
    component: AdminIBNProviderMgmt,
  },
  {
    path: "/index/ibn-mapping-management",
    name: "IBAN Provider Mapping",
    component: AdminIBNProviderMapping,
  },
  {
    path: "/index/entity-type-management",
    name: "Entity Type Management",
    component: AdminEntityTypeManagement,
  },
  {
    path: "/index/role-management",
    name: "Role Management",
    component: AdminRoleManagement,
  },
  {
    path: "/index/wallet-owner-settings",
    name: "Owner Settings",
    icon: "",
    component: AdminWalletOwnerSettings,
  },
  {
    path: "/index/add-wallet-owner",
    name: "Add Wallet Owner",
    icon: "",
    component: AdminAddWalletOwner,
  },
  // {
  //   path: "/index/add-new-business-nature",
  //   name: "Add New Business Nature",
  //   icon: "",
  //   component: AdminAddNewBusinessNature,
  // },
  {
    path: "/index/mapping-business-nature",
    name: "Mapping Business Nature",
    icon: "",
    component: AdminMappingBusinessNature,
  },
  {
    path: "/index/mapping-entity-type",
    name: "Mapping Entity Type",
    component: AdminMappingEntityType,
  },
  {
    path: "/index/mapping-role",
    name: "Role Mapping",
    component: AdminMappingRole,
  },
  {
    path: "/index/Gateway-Management",
    name: "Dashboard",
    component: adminGatewayManagement,
  },
  {
    path: "/index/gatewayManagement",
    name: "Gateway Management",
    component: AdminGatewayManagement,
  },
  {
    path: "/index/memberMapping",
    name: "Member Mapping",
    component: MemberMapping,
  },
  //Admin--Gateway Management Start
  {
    path: "/index/AdminGateway-Managements",
    name: "Dashboard",
    component: gatewayManagementAdmin,
  },
  {
    path: "/index/GatewayManagementAdmin",
    name: "Gateway Management",
    component: GatewayManagementAdmin,
  },
  {
    path: "/index/AdminMemberMapping",
    name: "Member Mapping",
    component: AdminMemberMapping
  },


  //Admin--Gateway Management End


  {
    path: "/index/AdminFraudRisk-Management",
    name: "Dashboard",
    component: adminFraudRiskManagement,
  },
  {
    path: "/index/RiskRule",
    name: "Risk Rule",
    component: AdminRiskRuleManagement,
  },
  {
    path: "/index/RiskRuleMapping",
    name: "Risk Rule Mapping",
    component: AdminRiskRuleMapping,
  },
  {
    path: "/index/adminAddRiskRuleMapping",
    name: "Add Risk Rule Mapping",
    component: AdminAddRiskRuleMapping,
  },
  {
    path: "/index/AdminCurrency-Management",
    name: "Dashboard",
    component: adminCurrencyManagement,
  },
  {
    path: "/index/CurrencyMaster",
    name: "Currency Master",
    component: AdminCurrencyMaster,
  },
  {
    path: "/index/CurrencyMapping",
    name: "Currency Mapping",
    component: AdminCurrencyMapping,
  },
  {
    path: "/index/AdminWallet-Management",
    name: "Dashboard",
    component: adminWalletManagement,
  },
  {
    path: "/index/WalletTransaction",
    name: "Wallet Transactions",
    component: AdminWalletTransaction,
  },
  {
    path: "/index/AdminKyc-Management",
    name: "Dashboard",
    component: adminKycManagement,
  },
  {
    path: "/index/CreateProofType",
    name: "Create Proof Type",
    component: AdminCreateProofType,
  },
  {
    path: "/index/CreateDocumentType",
    name: "Create Document Type",
    component: AdminCreateDocumentType,
  },
  {
    path: "/index/KycMapping",
    name: "KYC Mapping",
    component: AdminKycMapping,
  },
  {
    path: "/index/KycReport",
    name: "KYC Report",
    component: AdminKycReport,
  },
  {
    path: "/index/KybReport",
    name: "KYB Report",
    component: AdminKybReport,
  },
  {
    path: "/index/AdminFee-Master",
    name: "Dashboard",
    component: adminFeeMaster,
  },
  {
    path: "/index/FeeMaster",
    name: "Fee Master",
    component: AdminFeeMaster,
  },
  {
    path: "/index/FeeMapping",
    name: "Fee Mapping",
    component: AdminFeeMapping,
  },
  {
    path: "/index/KycDetails",
    name: "KYC Details",
    component: AdminViewKycDetails,
  },
  {
    path: "/index/KybDetails",
    name: "KYB Details",
    component: AdminViewKybDetails,
  },
  {
    path: "/index/AdminSetting",
    name: "Dashboard",
    component: adminSetting,
  },
  {
    path: "/index/Setting",
    name: "Generate Key",
    component: AdminSetting,
  },
  {
    path: "/index/CountrySettings",
    name: "Country Settings",
    component: CountrySettings,
  },
  {
    path: "/index/adminBankType",
    name: "Bank Type",
    component: AdminBankType,
  },
  {
    path: "/index/accountTypeAdmin",
    name: "Account Type",
    component: AccountTypeAdmin,
  },
  {
    path: "/index/mappingAccountType",
    name: "Account Type",
    component: AdminAccountTypeMapping,
  },
  {
    path: "/index/mappingBankType",
    name: "Mapping Bank Type",
    component: AdminMappingAccountType,
  },
  {
    path: "/index/adminTransferType",
    name: "Transfer Type",
    component: AdminTransferType,
  },
  {
    path: "/index/transferTypeMapping",
    name: "Mapping Transfer Type",
    component: AdminTransferTypeMapping,
  },
  {
    path: "/index/AdminBankMaster",
    name: "Bank Master",
    component: AdminBankMaster,
  },
  {
    path: "/index/adminMappingCountry",
    name: "Mapping Country",
    component: AdminMappingCountry,
  },
  {
    path: "/index/adminMappingBank",
    name: "Manage Bank",
    component: AdminMappingBank,
  },
  {
    path: "/index/AdminLanguageMaster",
    name: "Language Master",
    component: AdminLanguageMaster,
  },
  {
    path: "/index/adminMappingLanguage",
    name: "Mapping Language",
    component: AdminMappingLanguage,
  },
  {
    path: "/index/AdminPushNotification",
    name: "Push Notification",
    component: AdminPushNotification,
  },
  {
    path: "/index/AdminSMSProvider",
    name: "SMS Provider",
    component: AdminSMSProvider,
  },

  //--- ACTIVITY TRACKER ---//
  {
    path: "/index/ActivityTrackerAdmin",
    name: "Activity Tracker",
    component: ActivityTrackerAdmin,
  },

  {
    path: "/index/AdminModuleAllocationData",
    name: "Module Allocation",
    component: AdminModuleAllocationData,
  },

  {
    path: "/index/adminModuleAllocationList",
    name: "Module Allocation",
    component: AdminModuleAllocationList,
  },


  //--- ACTIVITY TRACKER END---//
  // Dealer

  {
    path: "/index/dealerProfile",
    name: "Dashboard",
    component: dealerProfile
  },
  {
    path: "/index/profile",
    name: "Profile",
    component: DealerProfile
  },

  {
    path: "/index/dealerDSRManagement",
    name: "Dashboard",
    component: dealerDsrManagement
  },
  {
    path: "/index/dsrMaster",
    name: "DSR Master",
    component: DealerDsrMaster
  },
  {
    path: "/index/dsrTransaction",
    name: "DSR Transaction",
    component: DealerDsrTransaction
  },
  {
    path: "/index/DealerAddNewUser",
    name: "Add New User",
    component: DealerAddNewUser
  },
  {
    path: "/index/DealerAddLimit",
    name: "Set DSR Limit",
    component: DealerAddLimit
  },
  {
    path: "/index/DealerAddNewDsrLimit",
    name: "Update User WithDraw Limit",
    component: DealerAddNewDsrLimit
  },
  {
    path: "/index/DealerUploadDsrLimit",
    name: "Dsr Upload",
    component: DealerUploadDsrLimit
  },
  {
    path: "/index/DealerViewDsrList",
    name: "DSR Deatils",
    component: DealerViewDsrList
  },

  {
    path: "/index/dealerWithdrawEMoney",
    name: "Dashboard",
    component: dealerWithdrawEMoney
  },
  {
    path: "/index/withdrawEMoney",
    name: "Withdraw E-Money",
    component: DealerWithdrawEMoney
  },
  {
    path: "/index/dealerPendingRequest",
    name: "Dashboard",
    component: dealerPendingRequest
  },
  {
    path: "/index/pendingRequest",
    name: "Pending Request",
    component: DealerPendingRequest

  },
  {
    path: "/index/dealerWalletManagement",
    name: "Dashboard",
    component: dealerWalletManagement
  },
  {
    path: "/index/walletTransactionDealer",
    name: "Wallet Transaction",
    component: DealerWalletTransaction

  },
  {
    path: "/index/summaryReport",
    name: "Summary Report",
    component: DealerSummaryReport

  },
  {
    path: "/index/feeReport",
    name: "Fee Report",
    component: DealerFeeReport,

  },
  {
    path: "/index/dealerUserManagement",
    name: "Dashboard",
    component: dealerUserManagement
  },
  {
    path: "/index/userManagement",
    name: "User Management",
    component: DealerBackOffice
  },
  {
    path: "/index/dealerAgentMaster",
    name: "Dashboard",
    component: dealerAgentMaster
  },
  {
    path: "/index/agentMaster",
    name: "Dsr Mapping",
    component: DealerAgentMaster
  },
  {
    path: "/index/DealerMultipleDsrMapping",
    name: "Mapping Dsr",
    component: DealerMultipleDsrMapping
  },
  {
    path: "/index/DealerAgentUpload",
    name: "Agent Upload",
    component: DealerAgentUpload
  },
  {
    path: "/index/DealerAddNewDsr",
    name: "Update Mapping",
    component: DealerAddNewDsr
  },
  {
    path: "/index/DealerViewUserMaster",
    name: "Report table",
    component: DealerViewUserMaster
  },

  //Banking Module Starts
  {
    path: "/index/bankmaster-dashboard",
    name: "Dashboard",
    component: BankMasterDashboard,
  },
  {
    path: "/index/bank-bankmaster",
    name: "Bank Master",
    component: BankMaster,
  },
  {
    path: "/index/cashlifting-dashboard",
    name: "Dashboard",
    component: CashLiftingDashboard,
  },
  {
    path: "/index/bank-cashlifting",
    name: "Cash Lifting",
    component: BankCashLifting,
  },
  {
    path: "/index/withdray-emoney-dashboard",
    name: "Dashboard",
    component: WithDrawEMoneyDashboard,
  },
  {
    path: "/index/bank-withdray-emoney",
    name: "Withdraw E-Money",
    component: BankWithdrawEMoney,
  },
  {
    path: "/index/user-management-dashboard",
    name: "Dashboard",
    component: UserManagementDashboard,
  },
  {
    path: "/index/bank-back-office",
    name: "Back Office",
    component: BankUserManagement,
  },

  //Banking Module Ends




];

export default dashRoutes;
